// This composable is used to format strings using common patterns that we don't need to keep rewriting
const useStringFormatting = () => {
  const toSentence = (words, conjunction = 'and') => {
    if (words.length === 1) return words[0];
    if (words.length === 2) return `${words[0]} ${conjunction} ${words[1]}`;
    if (words.length > 2) return `${words.slice(0, words.length - 1).join(', ')}, ${conjunction} ${words[words.length - 1]}`;
  };

  const toOrdinal = (num) => {
    // 1 to 1st, 12 to 12th, 52 to 52nd, etc
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const doubleDigitValue = num % 100;
    return num + (suffixes[(doubleDigitValue - 20) % 10] || suffixes[doubleDigitValue] || suffixes[0]);
  };

  return { toSentence, toOrdinal };
};

export default useStringFormatting;
